<template>
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 10.0005C11.6236 10.0005 13.75 7.87381 13.75 5.25055C13.75 2.62729 11.6236 0.500549 9 0.500549C6.37637 0.500549 4.25 2.62729 4.25 5.25055C4.25 7.87381 6.37637 10.0005 9 10.0005ZM9 1.68805C10.9646 1.68805 12.5625 3.28598 12.5625 5.25055C12.5625 7.21475 10.9646 8.81305 9 8.81305C7.03543 8.81305 5.4375 7.21364 5.4375 5.25055C5.4375 3.28598 7.03691 1.68805 9 1.68805ZM10.8814 11.7818H7.11855C3.56756 11.7818 0.6875 14.6615 0.6875 18.2129C0.6875 18.9231 1.26344 19.4994 1.97371 19.4994H16.027C16.7373 19.5005 17.3125 18.9254 17.3125 18.2129C17.3125 14.6615 14.4328 11.7818 10.8814 11.7818ZM16.0248 18.313H1.97371C1.91953 18.313 1.875 18.2685 1.875 18.2129C1.875 15.322 4.22773 12.9693 7.11855 12.9693H10.8777C13.7723 12.9693 16.125 15.322 16.125 18.2129C16.125 18.2685 16.0805 18.313 16.0248 18.313Z"
      fill="white"
    />
  </svg>
</template>
